<template>
	<section class="view-venue-detailform">
		<header>
			<h1>{{ venueModel.attributes.name }}</h1>
		</header>

		<form v-on:submit="Handle_OnSubmitForm">
			<label>
				<h6>Venue Name</h6>
				<input
					name="name"
					placeholder="Venue Name"
					type="text"
					v-model="venueModel.attributes.name"
				/>
			</label>

			<label>
				<span>Address</span>
				<input type="text" v-model="venueModel.attributes.address" />
			</label>

			<label>
				<h6>Website</h6>
				<input name="website" placeholder="Website" type="text" v-model="venueModel.website" />
			</label>

			<label>
				<h6>Phone Number</h6>
				<input name="phone" placeholder="Phone" type="text" v-model="venueModel.attributes.phone" />
			</label>

			<label>
				<h6>Additional Notes</h6>
				<textarea name="notes" placeholder="Anything else you think we should know?"></textarea>
			</label>

			<header>
				<h3>Details</h3>
			</header>

			<fieldset class="venue-attributes">
				<label>
					<input class="switch" name="billiards" type="checkbox" v-model="venueModel.billiards" />
					<span>Billiards Table</span>
				</label>
				<label>
					<input class="switch" name="cashOnly" type="checkbox" v-model="venueModel.cashOnly" />
					<span>Cash Only</span>
				</label>
				<label>
					<input class="switch" name="darts" type="checkbox" v-model="venueModel.darts" />
					<span>Dart Board</span>
				</label>
				<label>
					<input class="switch" name="foosball" type="checkbox" v-model="venueModel.foosball" />
					<span>Foosball Table</span>
				</label>
				<label>
					<input class="switch" name="freeTable" type="checkbox" v-model="venueModel.freeTable" />
					<span>Free Table</span>
				</label>
				<label>
					<input class="switch" name="gambling" type="checkbox" v-model="venueModel.gambling" />
					<span>Gambling Allowed</span>
				</label>
				<label>
					<input class="switch" name="hasFood" type="checkbox" v-model="venueModel.hasFood" />
					<span>Serves Food</span>
				</label>
				<label>
					<input class="switch" name="hasLeague" type="checkbox" v-model="venueModel.hasLeague" />
					<span>Has League</span>
				</label>
				<label>
					<input class="switch" name="livemusic" type="checkbox" v-model="venueModel.livemusic" />
					<span>Live Music</span>
				</label>
				<label>
					<input class="switch" name="pingPong" type="checkbox" v-model="venueModel.pingPong" />
					<span>Ping Pong</span>
				</label>
				<label>
					<input class="switch" name="shuffleboard" type="checkbox" v-model="venueModel.shuffleboard" />
					<span>Shuffleboard</span>
				</label>
				<label>
					<input class="switch" name="skeeball" type="checkbox" v-model="venueModel.skeeball" />
					<span>Skeeball</span>
				</label>
				<label>
					<input class="switch" name="smoking" type="checkbox" v-model="venueModel.smoking" />
					<span>Smoking Allowed</span>
				</label>
				<label>
					<input class="switch" name="snooker" type="checkbox" v-model="venueModel.snooker" />
					<span>Snooker Table</span>
				</label>
				<label>
					<input class="switch" name="table7" type="checkbox" v-model="venueModel.table7" />
					<span>7' Table</span>
				</label>
				<label>
					<input class="switch" name="table8" type="checkbox" v-model="venueModel.table8" />
					<span>8' Table</span>
				</label>
				<label>
					<input class="switch" name="table9" type="checkbox" v-model="venueModel.table9" />
					<span>9' Table</span>
				</label>
				<label>
					<input class="switch" name="tournaments" type="checkbox" v-model="venueModel.tournaments" />
					<span>Has Tournaments</span>
				</label>
			</fieldset>

			<fieldset>
				<button>Submit Revision</button>
			</fieldset>
		</form>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Full venue detail editing form with all attribute checkboxes.
	 * Emits submit event with the venue model for parent to handle saving.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueDetailForm extends ViewBase {
		/**
		 * The venue model to edit
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop()
		public venueModel!: ChalkySticks.Model.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle form submission. Emits to parent for saving.
		 *
		 * @param SubmitEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnSubmitForm(e: SubmitEvent): Promise<void> {
			e.preventDefault();

			this.$emit('submit', this.venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	@import '~@chalkysticks/sass/src/app/ui/icon.scss';
	@import '~@chalkysticks/sass/src/app/form.scss';
	@import '~@chalkysticks/sass/src/app/typography.scss';
	@import '~@chalkysticks/sass/src/app/ui/tags.scss';

	.view-venue-detailform {
		form {
			margin: 0 auto;
			max-width: 100%;
			padding: 1rem;
			width: 600px;
		}

		.venue-attributes {
			display: grid;
			grid-gap: 0.5rem;
			grid-template-columns: repeat(3, 1fr);
		}
	}

	// Media Queries
	// ---------------------------------------------------------------------------

	@include media-query('mobile-portrait') {
		.view-venue-detailform {
			.web-links {
				text-align: center;
			}

			.venue-attributes {
				display: grid;
				grid-gap: 0.25rem;
				grid-template-columns: repeat(2, 1fr);
			}
		}
	}
</style>
